import React from 'react';
import Icon from '../../../../../elements/icons/Icon';

function MeetingInProgramLocation(props) {
    const { className = '', meeting, style = {} } = props;

    if (!meeting.location) return;

    return (
        <p className={[className, 'text', 'location'].join(' ')} style={style}>
            <Icon src="/img/location.png" color={style.color} size={14} />
            {meeting.location.name}
        </p>
    );
}

export default MeetingInProgramLocation;
